import styled from 'react-emotion'

const TabText = styled('span')(({ active }) => ({
    fontFamily: 'Montserrat, sans-serif',
    color: active ? '#fff' : '#333',
    fontWeight: 700
}))

export default TabText


// WEBPACK FOOTER //
// ./src/components/TabTextComponent.jsx